import { ReCaptcha } from '../core/recaptcha';
import { axiosAdmin } from './axios';
import { AxiosResponse } from 'axios';
import { X_TOKEN_HEADER_NAME } from '../core/variables';
import { AUTH_FETCH_PATH } from '../core/paths';
import { ILoginProps } from '../interfaces/loginProps';
import { ISetPasswordProps } from '../interfaces/setPasswordProps';
import { IAdminUser } from '../interfaces/adminUser';
import { AdminUserRole } from '../enums/adminUserRole';

export namespace AdminAuthService {
  const baseUrl = AUTH_FETCH_PATH;

  export function refresh(): Promise<IAdminUser> {
    return axiosAdmin.post<IAdminUser>(baseUrl + '/refresh', {}).then(({ data }) => data);
  }

  export function login({ email, password }: ILoginProps): Promise<IAdminUser> {
    return new Promise((resolve) => {
      ReCaptcha.getToken(ReCaptcha.LOGIN, token => {
        resolve(axiosAdmin.post<IAdminUser>(
          baseUrl + '/login',
          { email, password },
          {
            headers: { [X_TOKEN_HEADER_NAME]: token },
          }
        ).then(({ data }) => data));
      });
    });
  }

  export function logout(): Promise<AxiosResponse> {
    return axiosAdmin.get(baseUrl + '/logout');
  }

  export function setPassword({
                                password,
                                token,
                                tokenId,
                                reset,
                              }: ISetPasswordProps): Promise<IAdminUser> {
    return new Promise(resolve => {
      ReCaptcha.getToken(reset ? ReCaptcha.FORGOT_PASSWORD_CHANGE : ReCaptcha.SET_PASSWORD, captchaToken => {
        resolve(axiosAdmin.post<IAdminUser>(
          baseUrl + (reset ? '/reset-password/change' : '/set-password'),
          { password, token, tokenId },
          {
            headers: {
              [X_TOKEN_HEADER_NAME]: captchaToken,
            }
          }
        ).then(({ data }) => data));
      });
    });
  };

  export function changePassword(oldPassword: string, newPassword: string): Promise<IAdminUser> {
    return axiosAdmin.post<IAdminUser>(baseUrl + '/change-password', { oldPassword, newPassword })
      .then(({ data }) => data);
  }

  export function initAdmin(email: string): Promise<IAdminUser> {
    return axiosAdmin.post<IAdminUser>('/users/internal', {
      email,
      role: AdminUserRole.SUPERUSER
    }).then(({ data }) => data);
  }

  export function forgotPassword(email: string): Promise<any> {
    return new Promise((resolve) => {
      ReCaptcha.getToken(ReCaptcha.FORGOT_PASSWORD_INIT, token => {
        resolve(axiosAdmin.post(
          baseUrl + '/reset-password/init',
          { email },
          {
            headers: { [X_TOKEN_HEADER_NAME]: token },
          }
        ).then(({ data }) => data));
      });
    });
  };
}